import { render, staticRenderFns } from "./quotes.vue?vue&type=template&id=3caf9541&scoped=true&"
import script from "./quotes.vue?vue&type=script&lang=js&"
export * from "./quotes.vue?vue&type=script&lang=js&"
import style0 from "./quotes.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./quotes.vue?vue&type=style&index=1&id=3caf9541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caf9541",
  null
  
)

export default component.exports